export const formatJSON = (value: any): string =>
  JSON.stringify(value, undefined, 2);
